import { ClipLoader } from 'react-spinners';
import { Modal } from './Modal';

type Props = {
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title: string;
  message?: string;
  confirmText?: string;
  cancelText?: string;
  isDangerous?: boolean;
  nonDismissable?: boolean;
};

export const ConfirmModal = ({
  onClose,
  onConfirm,
  isLoading = false,
  title,
  message,
  confirmText = 'Confirm',
  cancelText = 'Cancel',
  isDangerous = false,
  nonDismissable = false,
}: Props) => (
  <Modal onClose={onClose} nonDismissable={nonDismissable}>
    <div className="text-center flex flex-col gap-4">
      <h2 className="text-xl text-brand font-medium">{title}</h2>
      {message && <p className="text-md text-white text-left">{message}</p>}

      <div className="grid grid-cols-2 gap-4 mt-4">
        <button className="btn outlined secondary" onClick={onClose}>
          {cancelText}
        </button>
        <button
          className={`btn contained ${isDangerous ? 'danger' : 'primary'}`}
          onClick={onConfirm}
          disabled={isLoading}
        >
          {isLoading && <ClipLoader size={18} speedMultiplier={0.5} color="#fff" />}
          {confirmText}
        </button>
      </div>
    </div>
  </Modal>
);